import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgSettings} from "~/assets/svg/settings.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmSettingsIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgSettings id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
